import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import "../../styles/open-pages/lead-management.css";
import { selectAuth } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import LeadLandingCommon from "../../components/lead-management/common/LeadLandingCommon";

const LeadManagement = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return (
    <HelmetWrapper title="WTF: Lead Management System">
      <Container className="bg-cloud-k px-50px" fluid>
        <LeadLandingCommon userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default LeadManagement;
